import store from "../../../Store";
import { toggleURLQuery } from "../../../helpers/UrlHelper";
import getDataCenters from "../../../ajax/actions/data-center/data_centers_get";

export function toggleDataCenterListFilter(e) {
  return function (dispatch) {
    let { name, value } = e.target;
    dispatch({ type: "TOGGLE-DATA-CENTER-LIST-FILTER", name, value });

    store.dispatch(getDataCenters(true));
  };
}

export function setDefaultDataCenterFiltersToURL(history) {
  return (dispatch, getState) => {
    let { data } = getState().dataCenterList;
    let { params } = data;
    Object.keys(params).map((key) => {
      if (
        params[key] !== `` &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        toggleURLQuery(key, params[key], history);
      }
    });
  };
}

export function resetDataCenterParams() {
  return (dispatch) => {
    dispatch({ type: "TOGGLE-RESET-DATA-CENTER" });
  };
}
